import { z } from 'zod';
import { cuid, dinheiro, isoDate } from './primitives.js';

/** Preco praticado: estritamente positivo (0 nao e preco). */
const precoPraticado = dinheiro.refine((v) => /[1-9]/.test(v), 'O preco praticado deve ser maior que zero');

export const praticadoItemSchema = z.object({
  itemId: cuid,
  tabelaId: cuid,
  condicaoId: cuid,
  /** Preco praticado COM IPI, a prazo (o mesmo da formacao; SPEC 9.5.2/9.5.3). */
  preco: precoPraticado,
});
export type PraticadoItemDto = z.infer<typeof praticadoItemSchema>;

/** POST /precificacao/praticados: lote (tudo ou nada); cada linha vira um registro novo (append-only). */
export const registrarPraticadosSchema = z
  .object({
    /** Data que resolve a vigencia da tabela (e o vinculo tabela x condicao). Default: hoje (UTC). */
    data: isoDate.optional(),
    itens: z.array(praticadoItemSchema).min(1).max(200),
  })
  .superRefine((v, ctx) => {
    const vistos = new Set<string>();
    v.itens.forEach((it, i) => {
      const k = `${it.itemId}|${it.tabelaId}|${it.condicaoId}`;
      if (vistos.has(k)) ctx.addIssue({ code: 'custom', path: ['itens', i], message: 'Item repetido para a mesma tabela e condicao no lote' });
      vistos.add(k);
    });
  });
export type RegistrarPraticadosDto = z.infer<typeof registrarPraticadosSchema>;

export interface PraticadoResponse {
  id: string;
  itemId: string;
  tabelaId: string;
  condicaoId: string;
  preco: string;
  recordedAt: string;
  criadoPorId: string | null;
  /** Nome de quem registrou (quando o usuario ainda existe na empresa). */
  criadoPorNome: string | null;
}

export interface RegistrarPraticadosResponse {
  gravados: PraticadoResponse[];
}

/** GET /precificacao/praticados: historico de um item numa tabela (mais recente primeiro). */
export const historicoPraticadosSchema = z.object({
  itemId: cuid,
  tabelaId: cuid,
  condicaoId: cuid.optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
export type HistoricoPraticadosQuery = z.infer<typeof historicoPraticadosSchema>;
